// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { default as ROICalculator } from "./calculator/roi_calculator"

// Initialize the ROI Calculator when on the calculator page
document.addEventListener('turbo:load', () => {
  if (document.getElementById('roi_chart')) {
    ROICalculator.init();
  }
});
